var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('NavBar'),_c('SideBar'),_c('v-main',{staticClass:"neutral"},[_c('router-view'),_c('LayoutToTopFab')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }